import React from 'react';

// Material UI
import Box, { BoxProps } from '@mui/material/Box';
import { Button, LinearProgress, ListItemText, Typography } from '@mui/material';

// API
import { JobRecord, JobStatus } from '../../api/api';
import JobStatusChip from '../results/JobStatusChip';

// Storage
import { removeJob } from '../../storage/MySearchesStore';

// Types
interface Props {
  job: JobRecord;
}

const SearchJobListItem = ({ job }: Props) => {
  function Item(props: BoxProps) {
    const { sx, ...other } = props;
    return (
      <Box
        sx={{
          p: 1,
          m: 1,
          ...sx,
        }}
        {...other}
      />
    );
  }

  const renderTimeUntilRunOrProgress = () => {
    switch (JobStatus[job.status] as unknown as JobStatus) {
      case JobStatus.QUEUED:
        return (
          <Typography variant="body2" color="textSecondary">
            Position in queue: {job.positionInJobQueue}
          </Typography>
        );
      case JobStatus.RUNNING:
        return <LinearProgress />;
      default:
        return null;
    }
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          p: 1,
          bgcolor: 'background.paper',
          borderRadius: 1,
          flexWrap: 'wrap',
        }}
      >
        {job.searchCriteria && (
          <>
            <Item sx={{ width: '150px' }}>
              <Typography variant="body2">
                <strong>Species:</strong> {job.searchCriteria.species}
              </Typography>
            </Item>
            <Item sx={{ width: '150px' }}>
              <Typography variant="body2">
                <strong>Gene:</strong> {job.searchCriteria.gene}
              </Typography>
            </Item>
            <Item sx={{ width: '250px' }}>
              <Typography variant="body2">
                <strong>Accession:</strong> {job.searchCriteria.accessionNumber || "Custom"}
              </Typography>
            </Item>
          </>
        )}
        <Item sx={{ flexGrow: 1 }}>{renderTimeUntilRunOrProgress()}</Item>

        <Item>
          <JobStatusChip jobStatus={job.status} />
        </Item>
      </Box>
    </Box>
  );
};

export default SearchJobListItem;
